export const ALL = 0;
export const IMAGE = 1;
export const VIDEO = 2;
export const AUDIO = 3;
export const DOCUMENT = 4;
